import { apiClient } from '@/services/apiClient';
import type { ClubsPublicResponse } from '@/types/api';

export async function fetchClubs() {
  return apiClient.get<ClubsPublicResponse>('/api/v1/clubs');
}
